import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
var _excluded = ["className", "children", "selected", "disabled", "onClickBack", "control"];
import PropTypes from 'prop-types';
import React, { isValidElement } from 'react';
import classNames from '@jd/jmtd-tools/es/classnames';
import DropdownOption from '../DropdownOption';
import FormControl from '../FormControl';
import Label from '../Label'; // 下拉菜单带控制选项

export default function DropdownControlOption(_ref) {
  var className = _ref.className,
      children = _ref.children,
      selected = _ref.selected,
      disabled = _ref.disabled,
      onClickBack = _ref.onClickBack,
      control = _ref.control,
      other = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement(DropdownOption, _extends({
    className: classNames('jmtd-dropdown-control-option', className),
    selected: selected,
    disabled: disabled,
    background: /*#__PURE__*/React.createElement("div", {
      className: "jmtd-dropdown-control-option-background",
      onClick: onClickBack
    })
  }, other), /*#__PURE__*/React.createElement(FormControl, {
    className: "jmtd-dropdown-control-option-form-control",
    control: control
  }, /*#__PURE__*/isValidElement(children) ? children : /*#__PURE__*/React.createElement(Label, {
    theme: "light"
  }, children)));
}
DropdownControlOption.propTypes = {
  className: PropTypes.string,
  children: PropTypes.node,
  control: PropTypes.node,
  size: PropTypes.oneOf(['large', 'middle', 'small', 'mini']),
  onClickBack: PropTypes.func,
  selected: PropTypes.bool,
  showArrow: PropTypes.bool,
  disabled: PropTypes.bool,
  expanded: PropTypes.bool
};
DropdownControlOption.defaultProps = {
  className: '',
  children: null,
  control: PropTypes.node,
  size: null,
  onClickBack: function onClickBack() {},
  selected: false,
  showArrow: false,
  disabled: false,
  expanded: false
};